import capitalizedName from '$utils/capitalizedName';
import sortWorkExperienceFunction from '$utils/sortWorkExperience';
import { ErrorMessageEn } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import {
  CandidateBuilder,
  SearchCandidateFilterTypes,
  SearchCandidateInput,
  SearchCandidateOutput,
} from '../candidates.types';

export const searchCandidate = (builder: CandidateBuilder) =>
  builder.query<SearchCandidateOutput, SearchCandidateInput>({
    query: ({
      Files,
      page,
      take,
      QualityStatus,
      Country,
      CountryGroup,
      Categories,
      Salary,
      OpenToWork,
      orderBy,
      Order,
      TenantIds,
      UserQuery,
    }) => {
      const params = new URLSearchParams();
      params.set('page', `${page}`);
      params.set('take', `${take}`);
      params.set('orderBy', `${orderBy}`);
      params.set('order', `${Order}`);

      Object.entries(SearchCandidateFilterTypes).forEach(([key, value]) => {
        if (UserQuery[value]) {
          UserQuery[value].forEach((singleValue) => {
            if (SearchCandidateFilterTypes.AllFields === value) {
              params.append('Everything[]', singleValue);
            } else params.append(`${key}[]`, singleValue);
          });
        }
      });

      const filesFilter = ['Video', 'CV', 'Reference'];

      filesFilter.forEach((singleFileFilter) => {
        if (Files?.toLowerCase()?.includes(singleFileFilter.toLowerCase())) {
          params.set(singleFileFilter, 'true');
        }
      });

      if (Salary) {
        try {
          const parsedSalary = parseInt(Salary, 10);
          params.append('SalaryUpperBound', `${parsedSalary}`);
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(err);
        }
      }

      if (QualityStatus) {
        QualityStatus.split(',').forEach((singleQualityStatus) => {
          params.append('QualityStatus', singleQualityStatus);
        });
      }

      if (Country) {
        Country.forEach((singleCountry) => {
          params.append('Country', singleCountry);
        });
      }

      if (CountryGroup) {
        CountryGroup.forEach((singleCountryGroup) => {
          const formattedCountryGroupName = singleCountryGroup.toLowerCase();
          let backendCountryGroupName = '';

          if (formattedCountryGroupName === 'other') {
            backendCountryGroupName = 'Rest of the world';
          } else {
            backendCountryGroupName = capitalizedName(singleCountryGroup);
          }

          params.append('CountryGroup', backendCountryGroupName);
        });
      }

      if (OpenToWork) {
        OpenToWork.split(',').forEach((singleOpenToWork) => {
          params.append('OpenToWork', singleOpenToWork);
        });
      }

      if (Categories) {
        Categories.split(',').forEach((singleCategory) => {
          params.append('Categories', singleCategory);
        });
      }

      if (TenantIds) {
        TenantIds.forEach((tenant) => {
          params.append('TenantIds', tenant);
        });
      }

      return {
        url: `/candidates/search?${params.toString()}`,
        method: 'GET',
      };
    },
    transformResponse: (res: SearchCandidateOutput) => {
      const formattedData = { ...res };
      formattedData.data = formattedData.data.map((singleCandidate) => {
        singleCandidate.CandidateWorkExperience =
          singleCandidate.CandidateWorkExperience?.sort(
            sortWorkExperienceFunction
          );
        return singleCandidate;
      });
      return formattedData;
    },
    transformErrorResponse: (error) => {
      if (error.status === 400) {
        errorHandler(
          '[getCandidatesSearch]',
          'Your search matched too many candidates. Please add additional filters to narrow down your results.',
          error.data,
          true
        );
      } else {
        errorHandler(
          '[getCandidatesSearch]',
          ErrorMessageEn.GetCandidatesFail,
          error.data,
          true
        );
      }
      return error.data;
    },
  });
